import { createStore } from "zustand/vanilla";
import { devtools } from "zustand/middleware";
import { DEFAULT_OTP_CHANNELS } from "../utils/resolveOtpChannels";
import { createWorkspaceSlice } from "./slices/workspaceSlice";
import { createDoctorSelectionSlice } from "./slices/doctorSelectionSlice";
import { createScheduleSlice } from "./slices/scheduleSlice";
import { createOtpSlice } from "./slices/otpSlice";
import { createPatientSlice } from "./slices/patientSlice";
import { createBookingSlice } from "./slices/bookingSlice";
import { createPaymentSlice } from "./slices/paymentSlice";
import { createUiSlice } from "./slices/uiSlice";
import { createFollowUpSlice } from "./slices/followUpSlice";
export function createUnifiedStore(options = {}) {
    const { verifiedPhone } = options;
    const otpChannels = options.otpChannels?.length
        ? options.otpChannels
        : [...DEFAULT_OTP_CHANNELS];
    return createStore()(devtools((...a) => ({
        ...createWorkspaceSlice(...a),
        ...createDoctorSelectionSlice(...a),
        ...createScheduleSlice(...a),
        ...createOtpSlice(...a),
        ...createPatientSlice(...a),
        ...createBookingSlice(...a),
        ...createPaymentSlice(...a),
        ...createFollowUpSlice(...a),
        ...createUiSlice(...a),
        otpChannels,
        otpChannel: otpChannels[0],
        ...(verifiedPhone
            ? verifiedPhone.channel === "email"
                ? {
                    otpChannel: "email",
                    patientEmail: verifiedPhone.email,
                    otpVerified: true,
                    otpSent: true,
                }
                : {
                    otpChannel: "phone",
                    countryCode: verifiedPhone.countryCode,
                    patientPhone: verifiedPhone.phoneNumber,
                    otpVerified: true,
                    otpSent: true,
                }
            : null),
    }), {
        name: "MedosUnifiedBooking",
        enabled: process.env.NODE_ENV !== "production",
    }));
}
